"use client";

import {
  DEFAULT_DRAWER_FILTERS,
} from "libs/state/src/lib/stores/tanstack/filters/filters.config";
import {
  useFiltersStore,
} from "libs/state/src/lib/stores/tanstack/filters/useFiltersStore";

import type {
  TDrawerDataFor,
  TDrawerDataMap,
  TDrawerOpenArgs,
  TUseDrawers,
} from "./useDrawers.config";

export const useDrawers = <
  TDrawer extends string,
  TDataMap extends TDrawerDataMap<TDrawer> = Record<never, never>,
>(): TUseDrawers<TDrawer, TDataMap> => {
  const { filters, replaceFilterGroup } = useFiltersStore();
  const [ activeDrawer ] = Object.entries(filters.drawers);
  const data = activeDrawer?.[1].data ?? null;

  const isOpen = (key: TDrawer) => activeDrawer?.[0] === key;

  const getData = <TKey extends TDrawer>(
    key: TKey,
  ): TDrawerDataFor<TDrawer, TDataMap, TKey> | null => isOpen(key)
    ? data as TDrawerDataFor<TDrawer, TDataMap, TKey>
    : null;

  const onOpen = <TKey extends TDrawer>(
    key: TKey,
    ...[ drawerData ]: TDrawerOpenArgs<TDrawer, TDataMap, TKey>
  ) => {
    replaceFilterGroup("drawers", {
      [key]: {
        data: drawerData ?? {},
      },
    });
  };

  const onClose = () => replaceFilterGroup("drawers", DEFAULT_DRAWER_FILTERS);

  return {
    data,
    getData,
    isOpen,
    onOpen,
    onClose,
  };
};
